module.exports = __webpack_public_path__ + "img/example_promtpay.dbf5d54b.png";